
/**
 * Module dependencies.
 */

import { color, units } from 'src/styles/utils';
import { ifProp, theme } from 'styled-tools';
import React, { ReactElement } from 'react';
import styled, { css } from 'styled-components';
import times from 'lodash/times';

/**
 * `Props` type.
 */

type Props = {
  className?: string,
  currentSlide: number,
  onClickDot: (index: number) => void,
  totalSlides: number
};

/**
 * `Wrapper` styled component.
 */

const Wrapper = styled.div`
  display: flex;
  grid-gap: ${units(2)};
`;

/**
 * `Dot` styled component.
 */

const Dot = styled.span<{ active: boolean }>`
  background-color: ${color('grey200')};
  cursor: pointer;
  height: 1px;
  transition: background-color ${theme('animations.defaultTransition')};
  width: ${units(4)};

  &:focus,
  &:hover {
    background-color: ${color('brown400')};
  }

  ${ifProp('active', css`
    background-color: ${color('brown400')};
  `)}
`;

/**
 * `SliderPagination` styled component.
 */

const SliderPagination = (props: Props): ReactElement => {
  const { className, currentSlide, onClickDot, totalSlides } = props;

  return (
    <Wrapper className={className}>
      {times(totalSlides, (index: number) => (
        <Dot
          active={currentSlide === index}
          key={index}
          onClick={() => onClickDot(index)}
        />
      ))}
    </Wrapper>
  );
};

/**
 * Export `SliderPagination` component.
 */

export default SliderPagination;
